module.exports = __webpack_public_path__ + "static/media/laptop-code.f1f3bc7d.svg";